import React, { Component } from "react";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import Http from "../../../Http";
import { withRouter } from "react-router-dom";
import { DynamicForm } from "../../../components/form/DynamicForm";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import BuscarGuia from "../../../components/BuscarGuia";
import { DialogComponent } from "../../../components/dialog/DialogComponent";
import EmbarqueGuias from "./EmbarqueGuias";
import Chofer from "../../Catalogos/choferes/Chofer";
import ACCESS from "../../../ACCESS";
import { AuthContext } from "../../../context/authContext";
import { STATUS_EMBARQUE } from '../../../helpers/constants';
import Toast from "react-hot-toast";

class Embarcar extends Component {
  idEmbarque = isNaN(this.props.match.params.id) ? null : this.props.match.params.id;

  state = {
    guias: [],
    FormData: new Form(
      [
        Form.Field("date-hour", "fecha", "Fecha", new Date(), [Validators.required], 4, [], [], [], false, true),
        Form.Field("text", "tractor", "Tractor", "", [Validators.required], 4),
        Form.Field("text", "caja", "Caja", "", [Validators.required], 4),
        Form.Field("select", "id_transporte", "Transporte", "", [Validators.required], 4),
        Form.Field("text", "remision", "Remisión", "", [Validators.required], 4),
        Form.Field("select", "id_circuito", "Circuito", "", [Validators.required], 4),
        Form.Field("select", "id_tipo_embarque", "Tipo de embarque", 2, [Validators.required], 4),
        Form.Field("autocomplete-async", "id_cliente", "Cliente", "", [], 4, [], [], [], false, false, '', 'search/cliente'),
        Form.Field("autocomplete-async", "id_chofer", "Chofer", "", [Validators.required], 4, [], [], [], false, false, '', 'search/operador'),
        Form.Field("hidden", "sello", "Sello", "", [], 4),
        Form.Field("hidden", "embarque_administrativo", "Embarque Administrativo", false, [], 4),
        Form.Field("hidden", "comentario", "Comentario", "", [], 8),
      ], [],
      this.idEmbarque ? `Editar Embarque ${this.idEmbarque}` : "Nuevo Embarque"
    ),
    dcfOpen: false,
    dcfFolio: "",
    add: false,
    status: 0,
    choferOpen: false,
    mode: "typing",
    loading: true,
    loadingData: true,
    loadingError: '',
    disabled: false,
  };

  componentDidMount() {
    const { hasAccess } = this.context;
    let { FormData } = this.state;
    if (hasAccess(ACCESS.EMBARQUE.EMBARQUE_ADMINISTRATIVO)) {
      FormData = Form.FieldMod(FormData, "embarque_administrativo", "Type", "checkbox");
      FormData = Form.FieldMod(FormData, "comentario", "Type", "text");
      FormData = Form.FieldMod(FormData, "comentario", "Col", this.idEmbarque ? 4 : 8);
      this.setState({ FormData });
    }
    this.FillForm().then((f) => {
      Form.ValueChange(FormData, {
        id_tipo_embarque: this.tipoEmbarqueChange,
      });
      let disabled = !hasAccess([ACCESS.EMBARQUE.CREAR_EMBARQUE, ACCESS.EMBARQUE.EDITAR_EMBARQUES_CREADAS_POR_EL_USUARIO,
        ACCESS.EMBARQUE.EDITAR_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.EDITAR_EMBARQUE_SIN_RESTRICCIONES,
        ACCESS.EMBARQUE.EDITAR_TODAS_EMBARQUES]);
      if (this.idEmbarque) {
        this.LoadPreds(this.idEmbarque).then(d => {
          if (d && STATUS_EMBARQUE.FIN_CIRCUITO === d.status && !hasAccess(ACCESS.EMBARQUE.EDITAR_EMBARQUE_SIN_RESTRICCIONES)) {
            disabled = true;
          }
          this.setState({ loadingData: false, loading: false, disabled });
        }).catch(() => {
          this.setState({ loadingError: 'Error al cargar', loadingData: false });
        })
      } else {
        this.setState({ loading: false, loadingData: false, disabled });
      }
    }).catch(() => {
      this.setState({ loadingError: 'Error al cargar', loadingData: false })
    });
  }

  componentDidUpdate(prevprops) {
    if (prevprops.match.params.id !== this.props.match.params.id) {
      this.idEmbarque = isNaN(this.props.match.params.id) ? null : this.props.match.params.id;
      this.setState({
        FormData: { ...this.state.FormData, Title: this.idEmbarque ? `Editar Embarque ${this.idEmbarque}` : "Nuevo Embarque" }
      })
    }
  }

  tipoEmbarqueChange = (field) => {
    let newForm = this.state.FormData;
    if (field.Value === "1") {
      newForm = Form.FieldMod(newForm, "id_cliente", "Disabled", false);
    } else if (field.Value === "2") {
      newForm = Form.FieldMod(newForm, "id_cliente", "Disabled", true);
    }
    this.setState({ FormData: newForm });
  };

  FillForm = async () => {
    let params = "?";
    if (this.idEmbarque) params = `${params}e=${this.idEmbarque}&`;
    try {
      const Res = await Http.get(`embarque/form${params}`);
      if (Res.error) return;
      const { FormData } = this.state;
      const { transportes = [], circuitos = [], tipos_embarque = [], clientes = [], choferes = [] } = Res.data;
      let newForm = FormData;
      newForm = Form.FieldOptions(FormData, "id_transporte", transportes, "id", "linea_transp_nombre");
      newForm = Form.FieldOptions(newForm, "id_circuito", circuitos, "id", "circuito");
      newForm = Form.FieldOptions(newForm, "id_tipo_embarque", tipos_embarque, "id", "tipo_embarque");
      newForm = Form.FieldOptions(newForm, "id_cliente", clientes, "id", "Label");
      newForm = Form.FieldOptions(newForm, "id_chofer", choferes, "id", "Label");
      this.setState({ FormData: newForm });
    } catch (error) {
      this.setState({ loadingError: 'Error al cargar el Formulario' })
    }
  };

  LoadPreds = async (id = null) => {
    let { FormData } = this.state;
    let { hasAccess } = this.context;
    try {
      let Res = await Http.get(`embarque/one/${id}`);
      const { status } = Res.data;
      if (!Res.error) {
        if (status >= 2 || !hasAccess([ACCESS.EMBARQUE.CREAR_EMBARQUE, ACCESS.EMBARQUE.EDITAR_EMBARQUES_CREADAS_POR_EL_USUARIO,
        ACCESS.EMBARQUE.EDITAR_EMBARQUES_SUCURSAL_DEL_USUARIO, ACCESS.EMBARQUE.EDITAR_EMBARQUE_SIN_RESTRICCIONES, ACCESS.EMBARQUE.EDITAR_TODAS_EMBARQUES])) {
          let disabled = true;
          if (hasAccess([ACCESS.EMBARQUE.EDITAR_EMBARQUE_SIN_RESTRICCIONES])) {
            disabled = false;
          }
          for (const [index] of FormData.Fields.entries()) {
            FormData.Fields[index].Disabled = disabled;
          }
        }
        FormData = Form.FieldMod(FormData, 'sello', 'Type', 'text');
        if (hasAccess(ACCESS.EMBARQUE.EMBARQUE_ADMINISTRATIVO)) {
          FormData = Form.FieldMod(FormData, "embarque_administrativo", "Type", "checkbox");
          FormData = Form.FieldMod(FormData, "comentario", "Type", "text");
          FormData = Form.FieldMod(FormData, "comentario", "Col", 4);
        }
        this.setState({
          FormData: Form.Patch(FormData, Res.data, true),
          status,
          loading: false
        });
        return Res.data;
      } else {
        this.setState({ loadingError: 'Error al cargar informacion(1)', loadingData: false });
      }
    } catch (error) {
      this.setState({ loadingError: 'Error al cargar informacion(2)', loadingData: false });
    }
    return null;
  };

  formChange = (form, field) => {
    this.setState({ FormData: Form.Change(form, field) });
  };

  guardar = async () => {
    const { guias = [], FormData, disabled } = this.state;
    const { hasAccess } = this.context;
    if (disabled) return;
    this.setState({ loadingSave: true });
    let Vals = Form.FieldsValues(FormData);
    let valid = Form.ValidateForm(FormData);
    if (valid !== true) {
      this.setState({
        loadingSave: false,
      });
      return Toast.error(`Error en el campo '${valid.name}'`);
    }

    if (!!this.idEmbarque && guias.length === 0 && hasAccess([ACCESS.EMBARQUE.AGREGAR_GUIAS_AL_EMBARQUE, ACCESS.EMBARQUE.AGREGAR_GUIAS_RESTRICCION_SUCURSAL])) {
      if (!hasAccess(ACCESS.EMBARQUE.EDITAR_EMBARQUE_SIN_RESTRICCIONES)) {
        return Toast.error("No hay guías");
      }
    }

    try {
      let Res = null;
      if (this.idEmbarque) {
        Vals.id = this.idEmbarque;
        Res = await Http.post(`embarque/edit`, { embarque: Vals, guias: guias.map(g => g.id) });
      } else {
        Res = await Http.post(`embarque/save`, { embarque: Vals });
      }

      if (!Res.error) {
        Toast.success(`Guardado Embarque #${Res.data.id}`);
        this.setState({
          dcfFolio: Res.data.id,
          dcfOpen: true,
          loadingSave: false,
          status: Res.data.status
        });
        if (!this.idEmbarque) {
          this.props.history.push(`/Guias/Embarque/${Res.data.id}`);
        } else {
          this.props.history.push(`/Guias/Embarques`);
        }
        return;
      } else {
        this.setState({ loadingSave: false });
        return Toast.error(Res.errMsg)
      }
    } catch (error) {

    } finally {
      this.setState({ loadingSave: false });
    }
  };

  onFolio = () => {
    this.setState({ dcfOpen: false });
  };

  seleccionadaGuia = (guia) => {
    this.setState((state) => {
      if (state.guias.some((sguia) => sguia.id === guia.id)) {
        Toast.error("La guia ya fue seleccionada")
      } else {
        state.guias = [
          { ...guia, nueva: true, linea: 'NUEVA GUIA' },
          ...state.guias,
        ];
        state.dgOpen = false;
        state.add = true;
      }
      return state;
    });
  };

  elimianarGuia = (id_guia) => {
    this.setState((state) => {
      state.guias = state.guias.filter((guia) => guia.id_guia !== id_guia);
      return state;
    });
  };

  onNewChofer = async (data) => {
    if (this.state.disabled) return;
    if (data.id) {
      const { FormData } = this.state;
      let newForm = {
        ...FormData,
        Fields: FormData.Fields.map(f => {
          if (f.Name === 'id_chofer') {
            f.Options = [{ Value: data.id, Label: `[${data.id}] ${data.chofer_nombre} ${data.chofer_apellido_paterno} ${data.chofer_apellido_materno}` }]
            f.Value = data.id;
          }
          return { ...f };
        })
      }

      this.setState({ FormData: newForm });
    }
  };

  render() {
    const {
      guias = [],
      FormData,
      dcfOpen,
      dcfFolio,
      status,
      add,
      loading,
      loadingSave = false,
      choferOpen,
      mode = "typing",
      loadingData,
      loadingError,
      disabled
    } = this.state;
    const { hasAccess } = this.context;

    if (loadingData) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <CircularProgress size={"50px"} color="primary" />
        <div><h3>Cargando...</h3></div>
      </div>
    }

    if (loadingError) {
      return <div style={{ width: '100%', height: 100, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', }} >
        <h3>{loadingError}</h3>
      </div>
    }

    return (
      <div>
        <DynamicForm
          form={FormData}
          disabled={disabled}
          formChange={this.formChange}
          onSubmit={this.onSubmit}
        />
        <div style={{ display: "flex", justifyContent: "flex-end", width: '100%' }}>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              disabled={disabled}
              variant="contained"
              onClick={() => {
                this.setState({ choferOpen: true });
              }}
            >
              Nuevo Chofer
            </Button>
          </div>
        </div>

        <div>
          <div>
            {hasAccess([ACCESS.EMBARQUE.AGREGAR_GUIAS_AL_EMBARQUE, ACCESS.EMBARQUE.AGREGAR_GUIAS_RESTRICCION_SUCURSAL]) && [STATUS_EMBARQUE.REGISTRADO, STATUS_EMBARQUE.GUIAS_ASIGNADAS, STATUS_EMBARQUE.LLEGADA_SUCURSAL].includes(status) && !disabled && (
              <div>
                <div style={{ borderBottom: '1px solid black', width: '100%' }} ><h4>Guias</h4></div>
                <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", }} >
                  <BuscarGuia
                    onSelect={this.seleccionadaGuia}
                    mode={mode}
                    estado={[1, 23]}
                  />
                </div>
              </div>)
            }

            {!!this.idEmbarque && (
              <div style={{ marginTop: 10, marginBottom: 10 }}>
                {!loading && (
                  <EmbarqueGuias
                    status={status}
                    id_embarque={this.idEmbarque}
                    guias={guias}
                    add={add}
                    onAdd={() => {
                      this.setState({ add: false });
                    }}
                    elimianarGuia={this.elimianarGuia}
                  />
                )}
              </div>)
            }
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 20 }}>
            {([STATUS_EMBARQUE.REGISTRADO, STATUS_EMBARQUE.GUIAS_ASIGNADAS, STATUS_EMBARQUE.LLEGADA_SUCURSAL, STATUS_EMBARQUE.EN_CREACION].includes(status)
              || hasAccess([ACCESS.EMBARQUE.EDITAR_EMBARQUE_SIN_RESTRICCIONES])) 
              && (<Button
                variant="contained"
                color="primary"
                onClick={this.guardar}
                disabled={loadingSave || disabled}
              >
                <div
                  style={{ marginRight: 10, padding: 0, height: 22 }}
                  hidden={!loadingSave}
                >
                  <CircularProgress color="secondary" size={20} />
                </div>
                Guardar Embarque
              </Button>
            )}
          </div>
        </div>

        <DialogComponent
          open={!!dcfOpen}
          title="Folio de embarque"
          onClose={() => this.onFolio()}
          options={["Aceptar"]}
        >
          <p
            style={{
              textAlign: "center",
              fontWeight: "bolder",
              fontSize: 30,
              margin: 0,
              lineHeight: "0.8",
            }}
          >
            #{dcfFolio}
          </p>
        </DialogComponent>

        <Dialog
          onClose={() => {
            this.setState({ choferOpen: false });
          }}
          open={!!choferOpen}
          aria-labelledby="customized-dialog-title"
        >
          <DialogContent>
            <Chofer
              modal={true}
              onSave={(data) => {
                this.setState({ choferOpen: false });
                this.onNewChofer(data);
              }}
            />
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

Embarcar.contextType = AuthContext;
export default withRouter(Embarcar);